import { render } from "./FolderCard.vue?vue&type=template&id=992f474c&scoped=true"
import script from "./FolderCard.vue?vue&type=script&lang=js"
export * from "./FolderCard.vue?vue&type=script&lang=js"

import "./FolderCard.vue?vue&type=style&index=0&id=992f474c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-992f474c"]])

export default __exports__